import { Status } from "../../models/status";

export const mockedWorkorderStatus: Status[] = [
  {
    code: "A",
    name: "Accepté",
    statusDatetime: new Date("2021-08-05T21:05:30.000Z"),
  },
  {
    code: "E",
    name: "Réactivé",
    statusDatetime: new Date("2021-08-05T21:05:30.000Z"),
  },
  {
    code: "F",
    name: "Travaux à planifier",
    statusDatetime: new Date("2021-08-05T21:05:30.000Z"),
  },
  {
    code: "L",
    name: "Travaux planifiés",
    statusDatetime: new Date("2021-08-05T21:05:30.000Z"),
  },
  {
    code: "N",
    name: "Travaux suspendus",
    statusDatetime: new Date("2021-08-05T21:05:30.000Z"),
  },
  {
    code: "P",
    name: "Créé",
    statusDatetime: new Date("2021-08-05T21:05:30.000Z"),
  },
  {
    code: "S",
    name: "Transféré",
    statusDatetime: new Date("2021-08-05T21:05:30.000Z"),
  },
  {
    code: "T",
    name: "Terminé",
    statusDatetime: new Date("2021-08-05T21:05:30.000Z"),
  },
  {
    code: "V",
    name: "Travaux en cours",
    statusDatetime: new Date("2021-08-05T21:05:30.000Z"),
  },
  {
    code: "X",
    name: "Refusé",
    statusDatetime: new Date("2021-08-05T21:05:30.000Z"),
  },
];
